<div class="monitoring-container container">
  <div class="row monitoring-body">
    <div class="col-12">

      <div class="row">
        <div class="col-12 menu-monitoring">
          <div class="section-link" [ngClass]="{'active': page === 'global'}" (click)="changePage('global')">Global
          </div>
          <div class="section-link" [ngClass]="{'active': page === 'monitoring'}" (click)="changePage('monitoring')">
            Monitoring</div>
          <div i18n="monitoring|@@failure" class="section-link" [ngClass]="{'active': page === 'logs'}" (click)="changePage('logs')">
            Défaillances</div>
        </div>
      </div>


      <div class="row selector-monitoring">
        <div i18n="monitoring|@@FilterBy" class="col-md-4 col-12 selector-text">
          Filtrer par
        </div>
        <div class="col-md-2 col-12" *ngIf="possibleValuesCompany && possibleValuesCompany[0]">

          <ng-select [searchable]='true' [items]="possibleValuesCompany" [bindLabel]="'value'" [bindValue]="'key'"
            [(ngModel)]="newValueSelectCompany" [virtualScroll]='true' (change)="handlerChangeCompany($event)"
            notFoundText="---" [clearable]='true' placeholder='Compagnie' i18n-placeholder="monitoring|@@company">
          </ng-select>
        </div>
        <div class="col-md-2 col-12" *ngIf="possibleValuesDevice && possibleValuesDevice[0]">

          <ng-select [searchable]='true' [items]="possibleValuesDevice" [bindLabel]="'value'" [bindValue]="'key'"
            [(ngModel)]="newValueSelectDevice" [virtualScroll]='true' (change)="handlerChangeDevice($event)"
            notFoundText="---" [clearable]='true' placeholder='Select. Terminal'
            i18n-placeholder="monitoring|@@terminal">
          </ng-select>
        </div>
        <div class="col-md-2 col-12" *ngIf="possibleValuesLocation && possibleValuesLocation[0]">
          <ng-select [searchable]='true' [items]="possibleValuesLocation" [bindLabel]="'value'" [bindValue]="'key'"
            [(ngModel)]="newValueSelectLocation" [virtualScroll]='true' (change)="handlerChangeLocation($event)"
            notFoundText="---" [clearable]='true' placeholder='Location' i18n-placeholder="monitoring|@@location">
          </ng-select>
        </div>
      </div>

      <div *ngIf="page === 'global'" class="container">
        <div class="row center">
          <div *ngFor="let device of filterDeviceStore" class="col-md-6 col-12 center">
            <app-monitoring-card [device]='device' [monitor]='getMonitor(device.id)'>
            </app-monitoring-card>
          </div>

        </div>
      </div>

      <div *ngIf="page === 'logs'" class="container">
        <div class="row">
          <div class="col-12">
            <div class="table-option-toggle">
              <div class="conatainer">

                <div class="row m-0 center firstRow">
                  <div class="col-12">
                    <span class="titleRow">Logs</span>
                  </div>
                </div>

                <div class="row m-0 center" *ngFor="let log of filterLogsStore">
                  <div class="col-12 center">
                    <span class="p-2">{{log.deviceName}} - <span class="status"
                        [ngClass]="{'critical': log.level === 'CRITICAL'}">{{log.level}}</span> - {{log.message}}</span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="page === 'monitoring'" class="container">
        <div class="row" *ngFor="let monitor of filterDeviceStoreMonitor">
          <div class="col-12">
            <div class="table-option-toggle">
              <div class="conatainer">

                <div class="row m-0 center firstRow">
                  <div class="col-12">
                    <span class="titleRow">Device : {{monitor.devicePtr.id}} /
                      {{monitor.devicePtr.companyIdentifier}}</span>
                  </div>
                </div>

                <div class="row m-0 center" *ngFor="let data of getBrutData(monitor)">
                  <div class="col-4 center">
                    <span class="p-2">{{data.key}}
                    </span>
                  </div>
                  <div class="col-8 center">
                    <span class="p-2">{{data.value}}</span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/monitoring/monitoring.component.html